<template>
  <div> <!--  v-if="!reload" -->
    <el-drawer
     class="text-left"
    :title="heading"
    append-to-body
    size="96.3%"
    :visible.sync="showModal"
    :class="bgClass"
    direction="btt">

      <div ref="body" class="padded" style="text-align: left; min-height: 83.7%; max-height: 450px; text-align: left; overflow: auto;">
        <slot></slot>
      </div>

      <hr />
      <div class="padded pull-right" :aria-busy="saving ? 'true' : null">
        <component v-if="footerComponent" v-bind="extraProps" :is="footerComponent"></component>
        <span class="popup__status" role="status">{{ savingStatusText }}</span>
        <el-button v-if="showCancel" @click="closeModal"><span v-if="showSave || showSavePublish">Cancel</span><span v-else>Close</span></el-button>
        <el-button v-if="showSave" ref="saveButton" type="success" :disabled="!allowSave || saving" :loading="savingAction === 'save'" @click="saveModal">Save</el-button>
        <el-button v-if="showSavePublish" ref="savePublishButton" type="warning" :disabled="!allowSave || saving" :loading="savingAction === 'save-publish'" @click="savePublishModal">{{ savePublishText }}</el-button>
      </div>

    </el-drawer>

    <el-button
      :type="buttonStyle"
      :class="buttonClass"
      :size="this.getButtonSize()"
      @click="openModal"
      :text="text"
      :plain="plain"
      :round="round"
      :circle="circle"
      :disabled="disableButton || (!allowViewOnly && isViewOnly())"
      :aria-label="buttonAriaLabel"
      :title="buttonTitle">
      <i v-show="buttonIcon" :class="buttonIcon"></i>
      <span v-if="showText">{{buttonText}}</span>
    </el-button>

  </div>
</template>

<script>


import {ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT} from '@/components/Data'


export default {
  name: 'popup',

  props: {
    heading: {
      type: String,
      default: 'Alert Message'
    },
    size: {
      type: String,
      default: 'small'
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    buttonText: {
      type: String,
      required: true,
      default: 'Open'
    },
    buttonType: {
      type: String,
      default: 'normal'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: true
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    escToClose: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function
    },
    beforeSave: {
      type: Function
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    buttonStyle: {
      type: String,
      default: 'info'
    },
    bgClass: {
      type: String,
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    disableButton: {
      type: Boolean,
      default: false
    },
    overideViewOnly: {
      type: Boolean,
      default: false
    },
    // XOL-586 (Q9): opt-in only. A READ-ONLY popup (the request Activity log) stays
    // enabled for a view-only user, who may open it but never changes anything there.
    // Default false keeps every other consumer (~40 call sites) disabled for View-Only,
    // exactly as before. Do not confuse it with the unused `overideViewOnly` above,
    // which nothing reads and which this prop deliberately does not wire.
    allowViewOnly: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    showSave: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    centerButton: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: true
    },
    footerComponent: {
      type: Object
    },
    extraProps: {
      type: Object
    },
    tableRef: {
      type: String,
      default: null
    },
    buttonAriaLabel: {
      type: String,
      default: null
    },
    buttonTitle: {
      type: String,
      default: null
    },
    showSavePublish: {
      type: Boolean,
      default: false
    },
    savePublishText: {
      type: String,
      default: 'Save + Publish'
    },
    // XOL-487: opt-in only. Default false keeps every existing consumer
    // (~40 call sites) byte-identical to today's close-then-emit behaviour —
    // that is the entire safety argument for this prop. Only RatesAction
    // opts in.
    keepOpenUntilSaved: {
      type: Boolean,
      default: false
    }
  },

  components: {
  },

  methods: {
    refresh () {
      this.$forceUpdate()
    },

    getButtonSize () {
      return this.showText ? this.buttonSize : (this.buttonSize === 'small' || this.buttonSize === 'mini' ? this.buttonSize : 'small')
    },

    enabledSave () {
      this.allowSave = true
    },

    disabledSave () {
      this.allowSave = false
    },

    openModal () {
      // Defensive clear (XOL-487): a stray in-flight flag from a previous
      // open should never carry over and disable the buttons on a fresh open.
      this.savingAction = null
      // XOL-490/493 item 7: a fresh open must not still announce the PREVIOUS
      // open's failure.
      this.lastOutcome = null
      // XOL-493: the same reasoning the two clears above apply to Popup's OWN
      // state, extended to the consumer's. saveModal() closes the drawer
      // without emitting `close`, so a consumer that resets on close never
      // runs after a rejected save — see ContactDetail's fieldErrors leak.
      // Additive: no existing consumer listens, so this is inert for the ~40
      // that do not opt in.
      this.$emit('open')
      this.showModal = true
    },

    saveModal () {

      // beforeSave gates the whole save (XOL-376): when provided and it returns
      // false, keep the modal open and do NOT emit @save or refresh the table —
      // the guard has already told the user what to fix. This honors the
      // contract documented at the DefaultTierTemplateButton call site; the old
      // behavior emitted @save even after a failed guard, so a blocked save
      // closed the drawer and hid the inline validation errors.
      // XOL-487: a blocked save must also bring the errors into view. This gate
      // returns BEFORE @save is emitted, so the parent never runs and cannot
      // scroll itself — RatesAction's scrollPopupTop() on its prepareRow-false
      // branch is therefore unreachable for the Save button (it is live for
      // Save + Publish, which has no gate here). Without this the user is told
      // to "fix the highlighted errors" while those errors sit off-screen above
      // a body scrolled down to the tier cards. Gated on keepOpenUntilSaved so
      // the other three beforeSave consumers stay byte-identical.
      if (this.beforeSave && !this.beforeSave()) {
        if (this.keepOpenUntilSaved) this.scrollToTop()
        return
      }

      if (!this.keepOpenUntilSaved) {
        this.showModal = false
        this.$emit('save')

        if (this.tableRef) {
          this.$events.emit(this.tableRef + '-refresh-table')
        }

        return
      }

      // XOL-487: keepOpenUntilSaved consumers (RatesAction) must not close the
      // drawer, or fire the tableRef refresh, until the server has actually
      // responded — saveSucceeded()/saveFailed() below own both from here on.
      // Guard re-clicks while a save is already in flight.
      if (this.savingAction) return
      this.savingAction = 'save'
      this.$emit('save')
    },

    savePublishModal () {
      // XOL-487: gated on keepOpenUntilSaved for the same reason as saveModal
      // above — only a keepOpenUntilSaved consumer calls saveSucceeded()/
      // saveFailed() to clear savingAction. A future consumer showing
      // Save + Publish without opting in would set savingAction here with no
      // handshake to ever clear it, permanently disabling both footer buttons
      // until the drawer is dismissed.
      if (!this.keepOpenUntilSaved) {
        this.$emit('save-publish')
        return
      }

      if (this.savingAction) return
      this.savingAction = 'save-publish'
      this.$emit('save-publish')
    },

    // XOL-487: called by a keepOpenUntilSaved consumer once the server
    // confirms the save. Safe to call twice — the savingAction guard makes
    // the second call a no-op, so the tableRef refresh fires exactly once.
    saveSucceeded () {
      if (this.savingAction === null) return
      this.savingAction = null
      this.lastOutcome = null
      this.showModal = false

      if (this.tableRef) {
        this.$events.emit(this.tableRef + '-refresh-table')
      }
    },

    // XOL-487: called by a keepOpenUntilSaved consumer when the server
    // rejects the save — OR when the user cancels the confirm dialog on a
    // Save + Publish action (RatesAction.onSavePublish's .catch also routes
    // here). The drawer stays open with its inline errors intact. Safe to
    // call twice (savingAction guard).
    //
    // Which button gets focus depends on which action was in flight — read
    // BEFORE clearing savingAction below, or the distinction is lost. A
    // cancelled Save + Publish confirm should return focus to Save +
    // Publish, not Save; refocusing the wrong button here shipped as a bug
    // once already (see the "wrong focus target on cancel" note in
    // RatesAction.vue's onSavePublish).
    saveFailed () {
      if (this.savingAction === null) return
      var wasPublish = this.savingAction === 'save-publish'
      this.savingAction = null
      // XOL-490/493 item 7: the live region goes silent on failure without
      // this — savingStatusText clears to '' the instant savingAction does,
      // so a screen-reader user hears nothing where a sighted user sees the
      // toast. Also set on a CANCELLED Save + Publish confirm (this method's
      // other caller, per the comment above) — true on both paths, which is
      // why the copy is "Not saved.", not "Save failed.".
      this.lastOutcome = 'failed'

      this.$nextTick(() => {
        var button = wasPublish ? this.$refs.savePublishButton : this.$refs.saveButton
        if (button && button.$el) {
          button.$el.focus()
        }
      })
    },

    // XOL-487: additive — inert unless a consumer calls it. Lets RatesAction
    // scroll a prepareRow() validation failure back into view when the user
    // has scrolled down to the tier cards.
    scrollToTop () {
      if (this.$refs.body) {
        this.$refs.body.scrollTop = 0
      }
    },

    closeModal (destroy = false) {
      // Clear first (XOL-487) — el-drawer's mask click / Esc / X also flip
      // showModal via .sync without going through this method (see the
      // showModal watcher below), so this is belt-and-braces for the path
      // that DOES come through here.
      this.savingAction = null
      // XOL-490/493 item 7: a dismissed drawer's next open must not still
      // announce a stale failure.
      this.lastOutcome = null
      this.$emit('close')
      this.showModal = false
//      this.allowSave = false

      if (destroy) {
        this.reload = true
        this.$nextTick(() => {
// TODO          this.$destroy()
        })
      }
    }
  },

  computed: {
    saving () {
      return this.savingAction !== null
    },

    // XOL-490/493 item 7: idle-after-failure announces "Not saved." — a pure
    // computed over plain data (lastOutcome), no watcher, no $nextTick,
    // because Popup.spec.js is mount-free and would not observe either.
    // savingAction's two branches take priority (an in-flight save always
    // wins over the previous outcome).
    savingStatusText () {
      if (this.savingAction === 'save-publish') return 'Saving and publishing…'
      if (this.savingAction === 'save') return 'Saving…'
      if (this.lastOutcome === 'failed') return 'Not saved.'
      return ''
    }
  },

  watch: {
    // el-drawer's mask click / Esc / X flip showModal via .sync without going
    // through closeModal() (XOL-487) — clear the in-flight flag here too so
    // a dismissed drawer never leaves stale disabled/loading buttons behind
    // on its next open.
    showModal (val) {
      if (!val) {
        this.savingAction = null
        // XOL-490/493 item 7: same reasoning as closeModal() — a dismissed
        // drawer's next open must not still announce a stale failure.
        this.lastOutcome = null
      }
    }
  },

  data () {
    return {
      allowSave: this.disableSave ? this.disableSave : true,
      showModal: false,
      reload: false,
      // XOL-487: which save action is in flight ('save' | 'save-publish' |
      // null). Tracked separately from a single boolean so a Save+Publish
      // request in flight doesn't also spin the Save button (and vice versa).
      savingAction: null,
      // XOL-490/493 item 7: the last SETTLED outcome (null | 'failed'), so
      // the live region can announce a failure after savingAction clears —
      // set by saveFailed(), cleared by saveSucceeded(), openModal(),
      // closeModal() and the showModal watcher (the same four points that
      // already clear savingAction).
      lastOutcome: null
    }
  },

  created () {

    this.$events.on(DISABLE_SAVE_EVENT, this.disabledSave)
    this.$events.on(ENABLE_SAVE_EVENT, this.enabledSave)

  },

  beforeDestroy () {
    this.$events.off(DISABLE_SAVE_EVENT, this.disabledSave)
    this.$events.off(ENABLE_SAVE_EVENT, this.enabledSave)
  }
}

</script>

<style scoped>
/* XOL-487: visually-hidden but screen-reader-audible status region. Do not
   rely on a global .sr-only class — this repo doesn't have one. */
.popup__status {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
